import React from 'react'
import {usePurchaseForm} from './PurchaseFormProvider'
import {BlockComponentProps} from '../index'
import CountrySelect from '../../lib/ui/CountrySelect'
import StateSelect from '../../lib/ui/StateSelect'
import SectionLabel from './SectionLabel'
import {usePurchase} from '../../PurchaseContext'
import {PurchaseFormBlockBase} from '../PurchaseForm'

export interface ShippingAddressStepProps extends PurchaseFormBlockBase {
  sectionId?: string
  TextFieldComponent: React.FC<any>
  ShippingFieldsLabelComponent?: React.FC<any>
  shippingSectionLabel?: string
}

export default function ShippingAddressFields(
  props: ShippingAddressStepProps & BlockComponentProps,
) {
  const {
    TextFieldComponent,
    ShippingFieldsLabelComponent = (props: {label?: string}) => (
      <SectionLabel {...props}>{props.label ?? 'Shipping'}</SectionLabel>
    ),
    ...config
  } = props

  const {
    useSameAddressForShipping,
    shippingCountryId: countryId,
    shippingAddress1,
    setShippingAddress1,
    shippingAddress1Error,
    shippingAddress2,
    setShippingAddress2,
    setShippingCountryId,
    shippingCountryIdError,
    shippingStateId,
    setShippingStateId,
    shippingStateIdError,
    shippingCity,
    setShippingCity,
    shippingCityError,
    shippingZipPostal,
    setShippingZipPostal,
    shippingZipPostalError,
    billingAddress1,
    billingAddress2,
    billingCountryId,
    billingStateId,
    billingCity,
    billingZipPostal,
  } = usePurchaseForm()
  const {selectedTicket} = usePurchase()

  const billingEnabled = selectedTicket?.billing_address_enabled
  const isDisabled = billingEnabled && useSameAddressForShipping

  const selectorsClass = `country-state-selector`

  return (
    <>
      <style>
        {`
        .${selectorsClass} {
          margin-bottom: 0px;
        }

        .${selectorsClass} > div > div {
          background-color: ${config.input.backgroundColor};
          border: ${config.input.border.width}px solid;
          border-color: ${config.input.border.color};
          border-radius: ${config.input.border.radius}px !important;
          padding-left: ${config.input.padding.left}px;
          padding-right: ${config.input.padding.right}px !important;
          padding-top: ${config.input.padding.top}px;
          padding-bottom: ${config.input.padding.bottom}px;
          font-size: ${config.input.fontSize}px;
          line-height: normal;
        }

        .${selectorsClass} > div > div:focus {
          background-color: ${config.input.backgroundColor};
        }
     
        `}
      </style>
      <div>
        <ShippingFieldsLabelComponent
          {...props}
          label={props.shippingSectionLabel}
        />
        <TextFieldComponent
          aria-label={`shipping_address address 1`}
          config={config}
          placeholder={'shippingAddress1'}
          value={isDisabled ? billingAddress1 : shippingAddress1}
          onChange={(e: any) => setShippingAddress1(e)}
          error={!!shippingAddress1Error}
          disabled={isDisabled}
        />
        <TextFieldComponent
          aria-label={`shipping_address address 2`}
          config={config}
          placeholder={'shippingAddress2'}
          value={isDisabled ? billingAddress2 : shippingAddress2}
          onChange={(e: any) => setShippingAddress2(e)}
          disabled={isDisabled}
        />
        <CountrySelect
          config={config}
          className={selectorsClass}
          value={isDisabled ? billingCountryId : countryId}
          onChange={(value) => setShippingCountryId(value)}
          defaultLabel={config.input.placeholder.shippingcountry}
          error={!!shippingCountryIdError}
          disabled={isDisabled}
        />
        <StateSelect
          config={config}
          className={selectorsClass}
          value={isDisabled ? billingStateId : shippingStateId}
          onChange={(value) => setShippingStateId(value)}
          countryId={isDisabled ? billingCountryId : countryId}
          defaultLabel={config.input.placeholder.shippingstate}
          error={!!shippingStateIdError}
          disabled={isDisabled}
        />
        <TextFieldComponent
          aria-label={`shipping_address city`}
          config={config}
          placeholder={'shippingcity'}
          name={`shipping_address.city`}
          value={isDisabled ? billingCity : shippingCity}
          onChange={(e: any) => setShippingCity(e)}
          error={!!shippingCityError}
          disabled={isDisabled}
        />
        <TextFieldComponent
          aria-label={`shipping_address postal`}
          config={config}
          placeholder={'shippingzipcode'}
          name={`shipping_address.zip_postal`}
          value={isDisabled ? billingZipPostal : shippingZipPostal}
          onChange={(e: any) => setShippingZipPostal(e)}
          error={!!shippingZipPostalError}
          disabled={isDisabled}
        />
      </div>
    </>
  )
}
